export const customStyles = {
    container: () => ({height: '40px'}),
    control: (base, {isFocused}) => ({
        ...base,
        border: isFocused ? '1.5px solid #17AD99' : '1.5px solid #B2BEC2',
        boxShadow: 'none',
        '&:hover': {border: isFocused ? '1.5px solid #17AD99' : undefined},
        ':active': {background: 'rgba(1, 145, 175, 0.15)'},
    }),
    menu: (provided) => ({
        ...provided,
        width: '95%',
        zIndex: 100,
    }),
    option: (provided, {isSelected}) => ({
        ...provided,
        height: '36px',
        backgroundColor: isSelected ? 'rgba(1, 145, 175, 0.15)' : undefined,
        color: 'black',
        '&:hover': {background: 'rgba(1, 145, 175, 0.15)', color: 'black'},
    }),
};

export const embFilterStyle = {
    container: () => ({height: 'auto'}),
    control: (base, {isFocused}) => ({
        ...base,
        border: isFocused ? '1.5px solid #17AD99' : '1.5px solid #B2BEC2',
        boxShadow: 'none',
        '&:hover': {border: isFocused ? '1.5px solid #17AD99' : undefined},
        ':active': {background: 'rgba(1, 145, 175, 0.15)'},
    }),
    menu: (provided) => ({
        ...provided,
        width: '95%',
        zIndex: 9999,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    option: (provided, {isSelected}) => ({
        ...provided,
        height: '36px',
        backgroundColor: isSelected ? 'rgba(1, 145, 175, 0.15)' : undefined,
        color: 'black',
        '&:hover': {background: 'rgba(1, 145, 175, 0.15)', color: 'black'},
    }),
};


// WEBPACK FOOTER //
// ./src/common/SelectStyles.js